'use client';

// T042 — Locale-aware 404 for /about.

import { AnimatedButton } from '@/components/ui/animated-button';
import { Link } from '@/i18n/navigation';

export default function AboutNotFound(): React.ReactNode {
  return (
    <div className="flex min-h-[50vh] flex-col items-center justify-center gap-4 p-8 text-center">
      <h2 className="text-heading-md">Page not found</h2>
      <p className="max-w-md text-body text-foreground-secondary">
        The page you&apos;re looking for doesn&apos;t exist. Head back home and try again.
      </p>
      <AnimatedButton asChild variant="secondary">
        <Link href="/">Go home</Link>
      </AnimatedButton>
    </div>
  );
}
